import React, {FC, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {Button, SelectNoFormik} from '../../../../_gori/partials/widgets'

type AssignManagerOption = {
  value: string
  label: string
}

type Props = {
  show: boolean
  handleClose: () => void
  onSave: (manager: AssignManagerOption | null) => Promise<boolean> | boolean
  managerOptions?: AssignManagerOption[]
}

const AssignManagerModal: FC<Props> = ({show, handleClose, onSave, managerOptions = []}) => {
  const intl = useIntl()
  const [selectedManager, setSelectedManager] = useState<AssignManagerOption | null>(null)
  const [isSaving, setIsSaving] = useState(false)

  const handleCloseModal = () => {
    if (isSaving) {
      return
    }
    setSelectedManager(null)
    handleClose()
  }

  const handleSave = async () => {
    setIsSaving(true)
    try {
      const success = await onSave(selectedManager)
      if (success) {
        setSelectedManager(null)
        handleClose()
      }
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <Modal
      id='gori_modal_assign_manager'
      tabIndex={-1}
      aria-hidden='true'
      centered
      dialogClassName='modal-size-md h-auto'
      contentClassName='modal-padding'
      show={show}
      backdrop='static'
      onHide={handleCloseModal}
    >
      <Modal.Header closeButton>
        <Modal.Title bsPrefix='fw-bolder fs-1 modal-title'>
          {intl.formatMessage({id: 'ASSIGN_MANAGER'})}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className='assign-manager-modal'>
        <div className='assign-manager-modal__section'>
          <h5 className='assign-manager-modal__title'>
            {intl.formatMessage({id: 'UPDATE_ASSIGNMENT'})}
          </h5>
          <SelectNoFormik
            className='assign-manager-modal__select'
            options={managerOptions}
            value={selectedManager}
            onChange={(value) => setSelectedManager(value)}
            placeholder={intl.formatMessage({id: 'SELECT_USER'})}
            isSearchable={false}
          />
        </div>
      </Modal.Body>
      <Modal.Footer className='border-top'>
        <div className='d-flex justify-content-end w-100 gap-3'>
          <Button
            className='btn btn-advanced-secondary'
            label={intl.formatMessage({id: 'CANCEL'})}
            loadingText={intl.formatMessage({id: 'CANCEL'})}
            event={handleCloseModal}
            disabled={isSaving}
          />
          <Button
            className='btn btn-advanced-primary'
            label={intl.formatMessage({id: 'SAVE'})}
            loadingText={intl.formatMessage({id: 'SAVE'})}
            event={handleSave}
            disabled={!selectedManager || isSaving}
            loading={isSaving}
          />
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export {AssignManagerModal}
